export function authenticateUser(appPassword: string | undefined): boolean {
  if (!appPassword) return true; // No password required

  const userPassword = prompt("Enter Password:");
  if (userPassword === appPassword) {
    return true;
  } else {
    alert("Incorrect password. Access denied.");
    window.location.href = "about:blank"; // Redirect to a blank page
    return false;
  }
}
